export default {
  'calendar': () => import('@icons/common/calendar.svg'),
  'circle-cancel': () => import('@icons/common/circle-cancel.svg'),
  'circle-plus': () => import('@icons/common/circle-plus.svg'),
  'close': () => import('@icons/common/close.svg'),
  'dummy': () => import('@icons/common/dummy.svg'),
  'edit': () => import('@icons/common/edit.svg'),
  'error': () => import('@icons/common/error.svg'),
  'help': () => import('@icons/common/help.svg'),
  'info': () => import('@icons/common/info.svg'),
  'input-clear': () => import('@icons/common/input-clear.svg'),
  'more': () => import('@icons/common/more.svg'),
  'push': () => import('@icons/common/push.svg'),
  'range-setting': () => import('@icons/common/range-setting.svg'),
  'return': () => import('@icons/common/return.svg'),
  'search': () => import('@icons/common/search.svg'),
  'search-cancel': () => import('@icons/common/search-cancel.svg'),
  'setting': () => import('@icons/common/setting.svg'),
  'share': () => import('@icons/common/share.svg'),
};
